import React, { useEffect, useState } from "react";
import { QuestionForm } from "../../modules/QuestionForm";
import { Grid } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useMst } from "../../mobx";
import { snackbarStore } from "../../mobx/ui/SnackbarStore";
import { useHistory } from "react-router-dom";

export default observer(function QuestionCreate() {
	const defaultQuestion = localStorage.getItem("same_question_md")
		? JSON.parse(localStorage.getItem("same_question_md")!)
		: undefined;
	const [loading, setLoading] = useState(false);
	const { questionsStore } = useMst();
	const { createQuestion } = questionsStore;
	const { push } = useHistory();

	useEffect(() => {
		if (defaultQuestion) {
			localStorage.removeItem("same_question_md");
		}
	}, []);

	const handleCreate = async (data: any) => {
		data.id = undefined;
		try {
			setLoading(true);
			await createQuestion(data, (id) => push(`/questions/edit/${id}`));
			setLoading(false);
		} catch (e) {
			snackbarStore.notifyError("Не удалось создать задачу");
		}
	};

	return (
		<Grid container direction={"column"} sx={{ width: "100%" }}>
			<QuestionForm loading={loading} onSubmit={handleCreate} defaultQuestion={defaultQuestion} />
		</Grid>
	);
});
